import React, { useState } from "react";
import Image from "../../resources/contacts_image.png";

const ACCESS_KEY = '30c0554c-4267-4495-8f2d-bf5f255910f1';

const Contacts = () => {

const [result, setResult] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const formData = new FormData(event.target);

    formData.append('access_key', ACCESS_KEY);

    const response = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult('Mail inviata con successo!');
      event.target.reset();
    } else {
      setError(data.message);
    }
    setLoading(false);
    setSubmitted(true);
  };

  const reset = () => {
    setResult('');
    setError(null);
    setLoading(false);
    setSubmitted(false);
  }


    return (
    <div className="page__section contacts" id="contacts">
      <h1 className='title'>Contattaci</h1>
      <hr></hr>
      <div className='contacts__pages'>


      <div className="mail__wrapper">
        <h2 className='subtitle'>Mandaci una mail!</h2>
        <div className="contacts__direct">
          <p className='contacts__describer'>Link diretto: </p>
          <a className='contacts__mailSender' href="mailto:b3.More2025@gmail.com">Invia una mail!</a>
        </div>
        {!submitted && (
          <form onSubmit={onSubmit}>
            <div className='contacts__nome'>
                <p className='contacts__nome__input'>Nome: </p>
                <input className='contacts__nome__input'type="text" name="name" required />
            </div>
            <div className='contacts__email'>
                <p className='contacts__describer'>E-Mail: </p>
                <input type="email" name="email" required />
            </div>
            <div className='contacts__messaggio'>
                <p className='contacts__describer'>Messaggio: </p>
                <textarea name="message" style={{resize: 'none'}} required></textarea>
            </div>
            <div className='contacts__invia'>
                <button className='contacts__invia__btn' type="submit" disabled={loading}>
                     Invia messaggio
                </button>
            </div>
          </form>
        )}
        { submitted && <button type="button" onClick={ reset }>Invia un nuovo messaggio...</button> }
        {result && <h2>{result}</h2>}
        {error && <h2>Error: {error}</h2>}
      </div>

      <div className='contacts__static'>
        <h2 className='subTitle'>I nostri profili GitHub</h2>
        <div className='contacts__contact'>
            <p>Brambilla Antonio: <a href='https://github.com/LeBramboix' target='_blank'>LeBramboix</a></p>
        </div>
        <div className='contacts__contact'>
            <p>Ciseria Gabriele: <a href='https://github.com/Cise07' target='_blank'>_CISE_</a></p>
        </div>
        <div className='contacts__contact'>
            <p>Dourka Rayan: <a href='https://github.com/dourko' target='_blank'>dourko</a></p>
        </div>
        <div className='contacts__contact'>
            <p>Forlani Giorgio: <a href='https://github.com/forlynss' target='_blank'>forlynss</a></p>
        </div>
        <div className='contacts__contact'>
            <p>Ponsini Thomas: <a href='https://github.com/thommypons' target='_blank'>thomas.ponsinii</a></p>
        </div>
        <div className='contacts__contact'>
            <p>Solitro Thomas: <a href='https://github.com/sdrogoooo' target='_blank'>soliz__</a></p>
        </div>
        <div className='contacts__contact'>
            <p>Zanotti Giovanni: <a href='https://github.com/GiZano' target='_blank'>GiZano</a></p>
        </div> 
      </div>
      <img className='contacts__image' src={Image}></img>
      </div>
      
    </div>
    );
};


export default Contacts;